import { makeStyles, withStyles } from "@material-ui/core/styles";
import Rating from "@material-ui/lab/Rating";

const useStyles = makeStyles((theme: any) => ({
  itemNotFound: {
    textTransform: "uppercase",
  },
  outerContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  innerContainer: (props: any) => ({
    display: "flex",
    flexDirection: "column",
    padding: props.matches ? "3rem 7rem" : "1rem 1rem",
  }),
  upperSection: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    paddingBottom: "3rem",
  },
  imagesSection: (props: any) => ({
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    height: props.matches ? "35.1rem" : "fit-content",
    width: props.matches ? "29rem" : "100%",
  }),
  largeImage: (props: any) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: props.matches ? "29rem" : "100%",
    height: props.images?.length === 0 ? "100%" : 0,
    paddingBottom: props.images?.length === 0 ? 0 : "100%",
    backgroundColor: theme.whiteSmokeColor,
    background: `no-repeat center/100% url(${
      props.images?.[props.currentImageStep]?.url
        ? props.images?.[props.currentImageStep]?.url
        : props.images?.[props.currentImageStep]
    })`,
  }),
  smallImages: (props: any) => ({
    display: "flex",
    height: "20%",
    width: props.matches ? "29rem" : "100%",
    gap: "0.2rem",
    marginTop: "0.5rem",
    overflowX: "auto",
    overflowY: "hidden",
    paddingBottom: "0.1rem",

    "&::-webkit-scrollbar": {
      height: props.matches ? "0.3rem" : "0.2rem",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "none",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.snowColor,
      borderRadius: "0.2rem",
    },
    "&:hover::-webkit-scrollbar-thumb": {
      backgroundColor: theme.gainsboroColor,
    },
  }),
  smallImage: (props: any) => ({
    minWidth: props.matches ? "5.5rem" : "3.5rem",
    maxWidth: props.matches ? "5.5rem" : "3.5rem",
    height: props.matches ? "5.5rem" : "3.5rem",
    objectFit: "cover",
    cursor: "pointer",
  }),
  badgeContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    display: "flex",
    justifyContent: "flex-start",
    height: "2rem",
  },
  badge: (props: any) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: props.matches ? "6rem" : "5rem",
    fontSize: props.matches ? "0.8rem" : "0.7rem",
    textTransform: "uppercase",
  }),
  soldoutBadge: {
    color: theme.darkSlateGrayColor,
    backgroundColor: theme.khakiColor,
  },
  popularBadge: {
    color: theme.snowColor,
    backgroundColor: theme.darkSlateGrayColor,
  },
  onsaleBadge: {
    color: theme.lightCoralColor,
    backgroundColor: theme.linenColor,
  },
  infoSection: (props: any) => ({
    display: "flex",
    flexDirection: "column",
    width: props.matches ? "50%" : "100%",
    gap: props.matches ? "1rem" : "0.5rem",
    marginTop: props.matches ? 0 : "1rem",
  }),
  categories: {
    display: "flex",
    justifyContent: "flex-start",
    columnGap: "0.5rem",
  },
  category: (props: any) => ({
    fontSize: props.matches ? "0.9rem" : "0.8rem",
    textTransform: "uppercase",

    "& a": {
      color: theme.darkSlateGrayColor,
    },
    "& span": {
      marginLeft: "0.5rem",
    },
  }),
  brandAndRatingAndNumberOfReviews: {
    display: "flex",
    justifyContent: "space-between",
  },
  brand: {
    fontWeight: "bold",
  },
  ratingAndNumberOfReviews: {
    display: "flex",
    alignItems: "center",
  },
  numberOfReviews: {
    marginLeft: "0.5rem",
  },
  name: (props: any) => ({
    fontSize: props.matches ? "1.1rem" : "0.9rem",
    textTransform: "capitalize",
  }),
  optionsAndisSoldOut: (props: any) => ({
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    border: `1px solid ${theme.snowColor}`,
    borderLeft: "none",
    borderRight: "none",
    padding: props.matches ? "1rem 0" : "0.5rem 0",
  }),
  sizeOrColorOptions: (props: any) => ({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    rowGap: props.matches ? "1rem" : "0.3rem",
    marginTop: "1.2rem",
  }),
  optionContainer: (props: any) => ({
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "column",
    rowGap: props.matches ? "0.5rem" : "0.3rem",
  }),
  optionLabel: (props: any) => ({
    fontSize: props.matches ? "0.9rem" : "0.8rem",
    color: theme.darkSlateGrayColor,
    fontFamily: theme.fontFamilyArchivo,
    textTransform: "uppercase",
  }),
  selectedOption: (props: any) => ({
    fontSize: props.matches ? "0.9rem" : "0.8rem",
    fontFamily: theme.fontFamilyLexendDeca,
    textTransform: "capitalize",
  }),
  options: (props: any) => ({
    width: "100%",
    display: "flex",
    flexDirection: "row",
    columnGap: props.matches ? "0.5rem" : "0.2rem",
    overflowX: "auto",
    paddingBottom: props.matches ? "0.2rem" : "0.1rem",

    "&::-webkit-scrollbar": {
      height: props.matches ? "0.3rem" : "0.2rem",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "none",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.snowColor,
      borderRadius: "0.2rem",
    },
    "&:hover::-webkit-scrollbar-thumb": {
      backgroundColor: theme.gainsboroColor,
    },
  }),
  option: (props: any) => ({
    minWidth: "max-content",
    color: props.selected ? theme.whiteColor : theme.grayColor,
    backgroundColor: props.selected
      ? theme.darkGreyColor
      : theme.lightestGreyColor,
    border: `1px solid ${
      props.selected ? theme.whiteColor : theme.lighterGreyColor
    }`,
    padding: props.inQuickview
      ? props.matches
        ? "0.5rem 0.7rem"
        : "0.4rem 0.5rem"
      : props.matches
      ? "0.7rem 1rem"
      : "0.6rem 0.8rem",
    borderRadius: "6px",
    fontSize: "0.7rem",
    fontFamily: theme.fontFamilyLexendDeca,
    textTransform: "capitalize",
    cursor: props.disabled ? "not-allowed" : "pointer",
    "&:hover": {
      color: props.disabled
        ? theme.grayColor
        : props.selected
        ? theme.whiteColor
        : theme.dimGrayColor,
      backgroundColor: props.disabled
        ? theme.lightestGreyColor
        : props.selected
        ? theme.darkSlateGrayColor
        : theme.lighterSnowColor,
    },
  }),
  isSoldOut: (props: any) => ({
    position: "absolute",
    top: props.matches ? "1rem" : "0.5rem",
    right: 0,
    fontSize: "0.9rem",
    fontWeight: "bold",
    textTransform: "uppercase",
  }),
  addToCartContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "65%",
  },
  quantityContainer: (props: any) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: props.matches ? "1rem" : "0.5rem",
    marginTop: props.matches ? "0.5rem" : "0.5rem",
  }),
  quantityText: {
    fontSize: "0.9rem",
    textTransform: "uppercase",
  },
  quantityControl: (props: any) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: props.matches ? "fit-content" : "100%",
    borderRadius: "5px",
    border: `1px solid ${theme.snowColor}`,
  }),
  quantity: {
    fontSize: "0.9rem",
    width: "7rem",
    height: "100%",
    border: "none",
    textAlign: "center",
    "&::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "&::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "&:disabled": {
      backgroundColor: theme.whiteColor,
    },
  },
  addOrRemoveBtn: {
    height: "100%",
    border: "none",
    backgroundColor: "transparent",
    cursor: "pointer",
    padding: "0.9rem 1.1rem",
    fontFamily: theme.fontFamilyArchivo,
  },
  addToCartBtn: (props: any) => ({
    position: props.matches ? "relative" : "fixed",
    bottom: props.matches ? "unset" : 0,
    left: props.matches ? "unset" : 0,
    height: "3.3rem",
    width: "100%",
    marginTop: "1rem",
    border: "none",
    borderRadius: props.matches ? "7px" : 0,
    color:
      props?.isSoldOut ||
      props.quantity === 0 ||
      !props.selectedProductOrVariant ||
      props.selectedProductOrVariant === "CHOOSE_OPTION" ||
      props.selectedProductOrVariant === "UNAVAILABLE" ||
      props.quantity > props.stock
        ? theme.darkGrayColor
        : theme.whiteColor,
    background:
      props.isSoldOut ||
      props.quantity === 0 ||
      !props.selectedProductOrVariant ||
      props.selectedProductOrVariant === "CHOOSE_OPTION" ||
      props.selectedProductOrVariant === "UNAVAILABLE" ||
      props.quantity > props.stock
        ? theme.snowColor
        : `linear-gradient(to right, ${theme.blanchedAlmondColor}, ${theme.peachPuffColor})`,
    textTransform: "uppercase",
    fontSize: "0.9rem",
    fontWeight: 500,
    fontFamily: theme.fontFamilyArchivo,
    cursor:
      props.isSoldOut ||
      props.quantity === 0 ||
      !props.selectedProductOrVariant ||
      props.selectedProductOrVariant === "CHOOSE_OPTION" ||
      props.selectedProductOrVariant === "UNAVAILABLE" ||
      props.quantity > props.stock
        ? "not-allowed"
        : "pointer",
  }),
  lowerSection: {},
  descriptionSection: {},
  descriptionTitleContainer: (props: any) => ({
    display: "flex",
    columnGap: props.matches ? "2rem" : "1rem",
    overflowX: "auto",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    borderTop: `1px solid ${theme.snowColor}`,
    borderBottom: `1px solid ${theme.snowColor}`,
  }),
  descriptionTitle: (props: any) => ({
    padding: props.matches ? "1rem" : "0.5rem",
    border: "none",
    backgroundColor: "unset",
    fontSize: props.matches ? "0.9rem" : "0.8rem",
    fontFamily: theme.fontFamilyArchivo,
    textTransform: "uppercase",
    cursor: "pointer",
    color: props.isTabSelected ? theme.darkSlateGrayColor : theme.silverColor,
  }),
  descriptionContentContainer: {
    paddingBottom: "7rem",
  },
  descriptionContent: (props: any) => ({
    display: props.isTabSelected ? "flex" : "none",
    flexDirection: "column",
    marginTop: props.matches ? "1rem" : "0.5rem",
    marginBottom: props.matches ? "1rem" : "0.5rem",

    "& h1, h2, h3, h4, h5, h6": {
      marginTop: 0,
      marginBottom: 0,
    },
    "& table": {
      width: props.matches ? "calc(100% - 4rem)" : "calc(100% - 1rem)",
      margin: "0 auto",
      marginTop: "1rem",
      borderCollapse: "collapse",
      tableLayout: "fixed",
    },
    "& table, td, th": {
      border: `1px solid`,
    },
    "& td, th": {
      padding: props.matches ? "0.5rem" : "0.3rem",
      fontWeight: "normal",
      fontSize: props.matches ? "0.9rem" : "0.8rem",
    },
    "& th > p, td > p": {
      margin: 0,
      textAlign: "start",
    },
    "& ul, ol": {
      paddingLeft: props.matches ? "2rem" : "0.5rem",
    },
    "& li:first-child": {
      marginTop: "0.5rem",
    },
    "& li:not(:first-child)": {
      marginTop: "1rem",
    },
    "& blockquote": {
      background: "#f9f9f9",
      borderLeft: "10px solid #ccc",
      margin: "1.5em 10px",
      padding: "0.5em 10px",
    },
    "& blockquote:before": {
      color: "#ccc",
      content: "open-quote",
      fontSize: "4em",
      lineHeight: "0.1em",
      marginRight: "0.25em",
      verticalAlign: "-0.4em",
    },
    "& blockquote p": {
      display: "inline",
    },
    "& img": {
      width: "100%",
      height: "auto",
    },
  }),
  otherSection: {},
  youMightAlsoLikeSection: (props: any) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: props.matches ? "3rem 7rem" : "1rem 1rem",
    backgroundColor: theme.snowColor,
    textTransform: "uppercase",
  }),
  youMightAlsoLikeTitle: {
    width: "100%",
    fontSize: "0.9rem",
  },
  youMightAlsoLikeItems: (props: any) => ({
    display: "grid",
    gridGap: "3rem",
    gridTemplateColumns: "repeat(auto-fill, minmax(18rem, 1fr))",
    justifyItems: "center",
    overflowY: "hidden",
    height: "26rem",
    width: "max-content",
    maxWidth: "100%",
    marginTop: props.matches ? "3rem" : "1rem",
  }),
  reviewSection: (props: any) => ({
    display: "flex",
    flexDirection: "column",
    padding: props.matches ? "3rem 7rem" : "1rem 1rem",
    rowGap: "2rem",
  }),
  reviewTitle: {
    width: "100%",
    // fontSize: "0.9rem",
    textTransform: "uppercase",
  },
  createReview: {},
  reviewContent: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    columnGap: "2rem",
  },
  reviewLeftSection: {
    width: "30%",
  },
  reviewRightSection: {
    width: "60%",
    display: "flex",
    flexDirection: "column",
    rowGap: "1rem",
  },
  review: {},
  reviewUserAndDate: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "space-between",
  },
}));

export const StyledRating = withStyles((theme: any) => ({
  iconFilled: {
    color: theme.darkSlateGrayColor,
  },
  iconEmpty: {
    color: theme.whiteSmokeColor,
  },
}))(Rating);

export default useStyles;
